import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPrivacyPolicy } from "store/services/authPrivacyPolicy";

export const GetAllPrivacyPolicy = createAsyncThunk(
  "staticPage/getAllStaticPage",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getPrivacyPolicy(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);